import { FadeLoader } from "react-spinners"

/** The accent color of the current scheme (see tailwind.theme.js). */
const ACCENT = "rgb(var(--vm-primary))"

export default function Spinner({ color = ACCENT }: { color?: string }) {
  return <FadeLoader color={color} />
}
